import React, { useState } from 'react';
import './Services.css';

const services = [
  {
    id: 1,
    title: 'Wedding Cinematics',
    videoUrl: 'https://www.youtube.com/embed/0ZuALY2OVnw',
    description: 'Beautifully captured wedding moments crafted into cinematic experiences.'
  },
  {
    id: 2,
    title: 'Birthday Highlights',
    videoUrl: 'https://www.youtube.com/embed/rO_5Ze4Ldn4',
    description: 'Joyful birthday memories wrapped into fun, heartwarming edits.'
  },
  {
    id: 3,
    title: 'Corporate Films',
    videoUrl: 'https://www.youtube.com/embed/uG85cP-eAko',
    description: 'Professional visuals to represent your business, team, or product.'
  },
  {
    id: 4,
    title: 'Wedding Invitations',
    videoUrl: 'https://www.youtube.com/embed/5tchNOsJzD4',
    description: 'Creative and elegant wedding video invitations.'
  },
  {
    id: 5,
    title: 'Creative Invitations',
    videoUrl: 'https://www.youtube.com/embed/7iVup9GbrYY',
    description: 'Custom video invites for birthdays, baby showers, and more.'
  },
  {
    id: 6,
    title: 'Devanshi & Bhavik Wedding Caricature',
    videoUrl: 'https://www.youtube.com/embed/XWIH5GGX-pk',
    description: 'Caricature invites for wedding, birthday, and other special events.'
  },
  {
  id: 10,
  title: 'Multiart Decor art design and develope & Customisation Reel Created By R.DS Creations',
  videoUrl: 'https://www.youtube.com/embed/FYgnA_0yU_g',
  description: 'Corporate video'
},
  {
    id: 7,
    title: 'Whizzorathahub Highlight Video :- Video Created By R.DS Creations',
    videoUrl: 'https://www.youtube.com/embed/e0X8SUQWG1Q',
    description: 'Corporate video'
  },

  {
    id: 8,
    title: 'Omkar x Gauri Caricature',
    videoUrl: 'https://www.youtube.com/embed/e3I0VyMQ0vU',
    description: 'Caricature invites designed with a personalized touch.'
  },
  {

    id: 9,
    title: 'Sudeep x Karishma Wedding Invitee',
    videoUrl: 'https://www.youtube.com/embed/5q7D849sWwE',
    description: 'A unique caricature video invitation to make memories last.'
  },
  {
    id: 9,
    title: 'Whizzoratha Hub Corporate Reel Video 2nd :- Created By R.DS Creations',
    videoUrl: 'https://www.youtube.com/embed/J6kASfefLFE',
    description: 'Corporate Video'
  }
];

const Services = () => {
  const [selectedVideo, setSelectedVideo] = useState(null);

  const closeModal = () => setSelectedVideo(null);

  return (
    <section id="services" className="services-section">
      <h2>Our Services</h2>
      <div className="services-grid">
        {services.map((service) => (
          <div className="service-card" key={service.id} onClick={() => setSelectedVideo(service.videoUrl)}>
            <div className="video-wrapper">
              <iframe
                src={service.videoUrl}
                title={service.title}
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              ></iframe>
            </div>
            <h3>{service.title}</h3>
            <p>{service.description}</p>
          </div>
        ))}
      </div>

      {selectedVideo && (
        <div className="fullscreen-overlay" onClick={closeModal}>
          <div className="fullscreen-video" onClick={(e) => e.stopPropagation()}>
            <button className="close-btn" onClick={closeModal}>×</button>
            <iframe
              src={`${selectedVideo}?autoplay=1`}
              frameBorder="0"
              allow="autoplay; encrypted-media"
              allowFullScreen
              title="Fullscreen Service Video"
            ></iframe>
          </div>
        </div>
      )}
    </section>
  );
};

export default Services;